import React, { useEffect, useState } from "react";
import { Backdrop, Button, LogoLoader, PageTitle, showToast } from "../../../components";
import FormFieldSet from "../../../components/FormFields/FormFieldSet";
import axiosRequest from "../../../redux/slices/universal/axiosService";
import { WORKFORCE_API_URL } from "../../../redux/apiConfig";
import { useNavigate } from "react-router-dom";

const BankingSettings = () => {
  const [employees, setEmployees] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      // Fetch employees
      const empRes = await axiosRequest({
        method: "GET",
        url: `${WORKFORCE_API_URL}/userrefs/getAll`,
        params: {
          coll: "UserRef",
          lim: 1000,
          // fil: JSON.stringify({ isUser: true }),
          ret: "firstName lastName email uiid",
        },
      });
      const emps = empRes?.data?.data || [];
      const options = emps.map(emp => ({
        label: `${emp.firstName || ""} ${emp.lastName || ""} | ${emp?.email?.primary || ""}`.trim() || `User ${emp.uiid}`,
        value: emp.uiid,
      }));
      setEmployees(options);

      // Fetch OffTrxAccess
      const accessRes = await axiosRequest({
        method: "GET",
        url: `${WORKFORCE_API_URL}/off-trx/access`,
      });
      const userIds = accessRes?.data?.data?.userIds || [];
      setSelectedUsers(userIds);
    } catch (error) {
      console.error(error);
      showToast("Failed to fetch settings data", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      const res = await axiosRequest({
        method: "POST",
        url: `${WORKFORCE_API_URL}/off-trx/access`,
        data: {
          userIds: selectedUsers,
        },
      });
      if (res?.success) {
        showToast("Settings saved successfully", "success");
      } else {
        showToast("Failed to save settings", "error");
      }
    } catch (error) {
      console.error(error);
      showToast("Failed to save settings", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col h-full ">
      <div className="flex justify-between items-center sticky top-0 z-50  p-4 py-2">
        <PageTitle title="Off-Trx Settings" />
        <Button
          size="sm"
          title="Back"
          variant="outlined"
          icon="arrow_left_alt"
          onClick={() => navigate(-1)}
        />
      </div>
      <div className="flex-1 overflow-auto p-6">
        <div className="bg-white p-6 rounded shadow-sm border border-neutrals-100 max-w-2xl">
          <PageTitle title="Access Control" tag="h5"/>
          <p className="text-sm text-neutrals-500 mb-6 mt-2">Select users who are allowed to access the Off-Trx module. Admins have access by default.</p>
          
          <div className="mb-6 max-w-md">
            <FormFieldSet
              type="multiSelect"
              title="Allowed Users"
              options={employees}
              value={selectedUsers}
              placeholder={"Select users"}
              onChange={(newValues) => setSelectedUsers(newValues.map(Number))}
            />
          </div>

          <div className="flex justify-end pt-4 border-t border-neutrals-100">
            <Button
              title={loading ? "Saving..." : "Save Settings"}
              onClick={handleSave}
              disabled={loading}
            />
          </div>
        </div>
      </div>
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default BankingSettings;
